
import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Settings';
import list from './list';

const settings: ResourceProps = {
  name: 'settings',
  icon,
  options: { label: 'Configurações' },
  list
};

export default settings;